import { DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs } from 'cerialize';
import moment from 'moment-timezone';

export class FareReviewItem {
  @autoserialize
  reservationId: number;

  @autoserialize
  driverFirstName: string;

  @autoserialize
  driverLastName: string;

  @autoserializeAs(Date)
  pickupDate: Date;

  @autoserializeAs(Date)
  itineraryDate: Date;

  @autoserialize
  timeZone: string;

  @autoserialize
  transitProgramCode: string;

  @autoserialize
  stateCode: string;

  @autoserialize
  percentDeviation: number;

  @autoserialize
  dispatchedToLyft: boolean;

  @autoserialize
  calculatedDriverCommissionAmount: number;

  @autoserialize
  estimatedDriverCommissionAmount: number;

  @autoserialize
  fareReviewTriggerResultName: Array<string>;

  get displayDate(): Date {
    if (!isNullOrUndefined(this.pickupDate)) {
      return this.pickupDate;
    }
    return this.itineraryDate;
  }

  /**
   * TODO: Refactor later using https://www.npmjs.com/package/localdate
   */
  get formattedDisplayDate(): string {
    if (!isNullOrUndefined(this.pickupDate)) {
      return moment.tz(this.pickupDate, this.timeZone).format('M/DD/YY h:mm a z');
    }
    return moment(this.itineraryDate).format('M/DD/YY');
  }

  static OnSerialized(instance: FareReviewItem, json: any): void {
    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeDate(instance.pickupDate);
    }

    if (!isNullOrUndefined(instance.pickupDate)) {
      json.pickupDate = DateUtil.serializeLocalDate(instance.pickupDate);
    }
  }

  static OnDeserialized(instance: FareReviewItem, json: any): void {
    if (!isNullOrUndefined(json['pickupDate'])) {
      instance.pickupDate = DateUtil.deserializeDate(json['pickupDate']);
    }

    if (!isNullOrUndefined(json['itineraryDate'])) {
      instance.itineraryDate = DateUtil.deserializeLocalDate(json['itineraryDate']);
    }
  }
}
